import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_TYPES,
  FILTER_ADDED,
  FILTER_PERIOD,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_CLUSTERS,
  FILTER_PLATFORMS,
  FILTER_STATUSES,
  FILTER_CREATED_BY,
  FILTER_ACTIONS_TYPE,
  FILTER_REASONS,
} from 'scenes/SpendAdjustments/constants';
import {
  loadAffiliates,
  loadApplications,
  loadNetworks,
  loadClusters,
  loadPlatforms,
  loadStatuses,
  loadCreatedBy,
  loadActionTypes,
  loadTypes,
  loadReasons,
} from 'scenes/SpendAdjustments/sources/filters';

const DEPENDENCIES = {
  [FILTER_APPLICATIONS]: [FILTER_AFFILIATES],
  [FILTER_NETWORKS]: [FILTER_APPLICATIONS],
  [FILTER_CLUSTERS]: [FILTER_APPLICATIONS, FILTER_NETWORKS],
  [FILTER_PLATFORMS]: [FILTER_APPLICATIONS, FILTER_NETWORKS],
};

const AddedFilter = (props) => (
  <Filter.DateRangePicker
    timeZone={'utc'}
    title={'Added'}
    placeholder={'All'}
    name={FILTER_ADDED}
    {...props}
  />
);

const PeriodFilter = (props) => (
  <Filter.DateRangePicker
    timeZone={'utc'}
    title={'Period'}
    placeholder={'All'}
    name={FILTER_PERIOD}
    {...props}
  />
);

const AffiliatesFilter = (props) => (
  <Filter.MultiSelect
    title={'Affiliates'}
    placeholder={'All'}
    name={FILTER_AFFILIATES}
    variant={'outlined'}
    source={loadAffiliates}
    {...props}
  />
);

const ApplicationsFilter = (props) => (
  <Filter.MultiSelect
    title={'Applications'}
    placeholder={'All'}
    name={FILTER_APPLICATIONS}
    variant={'outlined'}
    source={loadApplications}
    depends={DEPENDENCIES[FILTER_APPLICATIONS]}
    {...props}
  />
);

const NetworksFilter = (props) => (
  <Filter.MultiSelect
    title={'Networks'}
    placeholder={'All'}
    name={FILTER_NETWORKS}
    variant={'outlined'}
    source={loadNetworks}
    withAll={false}
    depends={DEPENDENCIES[FILTER_NETWORKS]}
    {...props}
  />
);

const ClustersFilter = (props) => (
  <Filter.MultiSelect
    title={'Clusters'}
    placeholder={'All'}
    name={FILTER_CLUSTERS}
    variant={'outlined'}
    source={loadClusters}
    withAll={false}
    depends={DEPENDENCIES[FILTER_CLUSTERS]}
    {...props}
  />
);

const PlatformsFilter = (props) => (
  <Filter.MultiSelect
    title={'Platforms'}
    placeholder={'All'}
    name={FILTER_PLATFORMS}
    variant={'outlined'}
    source={loadPlatforms}
    withAll={false}
    depends={DEPENDENCIES[FILTER_PLATFORMS]}
    {...props}
  />
);

const StatusesFilter = (props) => (
  <Filter.MultiSelect
    title={'Statuses'}
    placeholder={'All'}
    name={FILTER_STATUSES}
    variant={'outlined'}
    source={loadStatuses}
    {...props}
  />
);

const ReasonsFilter = (props) => (
  <Filter.MultiSelect
    title={'Reasons'}
    placeholder={'All'}
    name={FILTER_REASONS}
    variant={'outlined'}
    source={loadReasons}
    {...props}
  />
);

const TypesFilter = (props) => (
  <Filter.MultiSelect
    title={'Types'}
    placeholder={'All'}
    name={FILTER_TYPES}
    variant={'outlined'}
    source={loadTypes}
    {...props}
  />
);

const ActionsTypeFilter = (props) => (
  <Filter.Select
    title={'Show'}
    name={FILTER_ACTIONS_TYPE}
    variant={'outlined'}
    placeholder={'All'}
    source={loadActionTypes}
    {...props}
  />
);

const CreatedByFilter = (props) => (
  <UserFilter
    title={'Created by'}
    placeholder={'All'}
    name={FILTER_CREATED_BY}
    variant={'outlined'}
    source={loadCreatedBy}
    {...props}
  />
);

export default {
  Types: TypesFilter,
  Added: AddedFilter,
  Period: PeriodFilter,
  Affiliates: AffiliatesFilter,
  Applications: ApplicationsFilter,
  Networks: NetworksFilter,
  Clusters: ClustersFilter,
  Platforms: PlatformsFilter,
  Statuses: StatusesFilter,
  ActionsType: ActionsTypeFilter,
  CreatedBy: CreatedByFilter,
  Reasons: ReasonsFilter,
};
